"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateMessageContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _GiftMessageTextField = require("../GiftMessageTextField/GiftMessageTextField");

var _GiftMessageSendAsSelect = _interopRequireDefault(require("../../../CreateGift/containers/GiftMessage/GiftMessageSendAsSelect"));

var _templates = require("../../../CreateGift/store/templates/templates.actions");

var _SelectSalesEmailTemplate = _interopRequireDefault(require("../SelectSalesEmailTemplate/SelectSalesEmailTemplate"));

var CreateMessageContainer = function CreateMessageContainer(_ref) {
  var name = _ref.name,
      control = _ref.control,
      giftId = _ref.giftId;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (giftId) {
      dispatch((0, _templates.loadTemplatesRequest)(giftId));
    }
  }, [dispatch, giftId]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    textAlign: "center",
    className: "Body-Small-Static"
  }, "This message will appear on the gift landing page your recipient will see")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    mt: 3,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageSendAsSelect.default, null)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_SelectSalesEmailTemplate.default, null))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageTextField.GiftMessageTextField, {
    onChange: function onChange() {},
    name: name,
    control: control
  })));
};

exports.CreateMessageContainer = CreateMessageContainer;